







































import Vue from 'vue';
import Component from 'vue-class-component';
import ServiceAgent from '@/services/serviceAgent';
import EventBus from '@/services/eventBus';
import Job from '@/objects/job';

const serviceAgent = new ServiceAgent();

@Component
export default class Admin extends Vue {
    commands: Job[] = [];

    ratingFile: any = [];

    mounted() {
        this.refreshCommands();
    }

    runCommand(command: Job) {
        if (!command.Running) {
            serviceAgent.RunCommand(command.Name);
            EventBus.$emit('openSnackbar', { snackbarText: `Command ${command.Name} succesfully runned`, snackbarSuccess: true });
        } else {
            EventBus.$emit('openSnackbar', { snackbarText: `Command ${command.Name} already runned`, snackbarSuccess: false });
        }
    }

    async refreshCommands() {
        EventBus.$emit('showLoader', true);

        const commandsResponse = await serviceAgent.GetAllJobManagerCommands();
        this.commands = commandsResponse.data.map((job: any) => new Job(job));

        EventBus.$emit('showLoader', false);
    }

    updateImdbRatings() {
        const formData = new FormData();
        formData.append('files', this.ratingFile[0], 'imdbRating');
        serviceAgent.UpdateImdbRatingsFromFile(formData);

        EventBus.$emit('openSnackbar', { snackbarText: 'Update Imdb rating started', snackbarSuccess: true });
    }
}
